import React from 'react';
import { Box, Typography } from '@material-ui/core';

import PathwayVideoCard from '../PathwayVideoCard';
import useStyles from './styles';

const PathwayVideos = ({ pathwayData, pathwayTitle }) => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Typography className={classes.title}>{pathwayTitle}</Typography>
      <ul className="pathway-list">
        {pathwayData.map((pathway) => (
          <li key={pathway?.id}>
            <PathwayVideoCard pathway={pathway} />
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default PathwayVideos;
